import React from 'react';
import { Table, Empty, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';

const { Text } = Typography;

export interface ResponseAnswer {
    id: number;
    questionId: number;
    questionText: string;
    questionType: string;
    numericValue: number | null;
    textValue: string | null;
    responseTimeSeconds: number | null;
}

interface AnswersTableProps {
    answers: ResponseAnswer[];
}

export const AnswersTable: React.FC<AnswersTableProps> = ({ answers }) => {
    if (!answers || answers.length === 0) {
        return (
            <Empty
                description={
                    <FormattedMessage id="responseIntegrity.answers.empty" />
                }
            />
        );
    }

    return (
        <Table<ResponseAnswer>
            rowKey="id"
            dataSource={answers}
            pagination={false}
            size="small"
            columns={[
                {
                    title: <FormattedMessage id="responseIntegrity.answers.question" />,
                    dataIndex: 'questionText',
                    render: (text: string, row) => (
                        <div>
                            <div>{text}</div>
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                {row.questionType}
                            </Text>
                        </div>
                    ),
                },
                {
                    title: <FormattedMessage id="responseIntegrity.answers.answer" />,
                    key: 'answer',
                    width: 240,
                    render: (_v, row) =>
                        row.numericValue !== null && row.numericValue !== undefined
                            ? row.numericValue
                            : row.textValue || <Text type="secondary">—</Text>,
                },
                {
                    title: <FormattedMessage id="responseIntegrity.answers.responseTime" />,
                    dataIndex: 'responseTimeSeconds',
                    width: 120,
                    align: 'right',
                    render: (v: number | null) =>
                        v === null || v === undefined ? '—' : `${v}s`,
                },
            ]}
        />
    );
};
